import { Globe, Check, ChevronDown } from "lucide-react";
import { languageOptions, useLocalization } from "@/lib/localization";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function AuthLanguageSelect() {
  const { language, messages, setLanguage } = useLocalization();
  const selectedLanguage = languageOptions.find((option) => option.code === language) || languageOptions[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex max-w-[11rem] items-center gap-2 rounded-full border-0 bg-secondary px-3 py-2 text-xs font-semibold text-foreground shadow-none outline-none transition-colors hover:bg-secondary/80 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:bg-secondary sm:px-3.5"
        >
          <Globe className="h-3.5 w-3.5 text-primary" />
          <span className="truncate">{selectedLanguage.nativeLabel}</span>
          <ChevronDown className="h-3.5 w-3.5 text-foreground/65" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="max-h-[min(20rem,calc(100dvh-2rem))] w-[min(14rem,calc(100vw-2rem))] rounded-xl border border-border bg-popover p-1 shadow-md outline-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
      >
        {languageOptions.map((option) => {
          const active = option.code === language;
          return (
            <DropdownMenuItem
              key={option.code}
              onClick={() => void setLanguage(option.code)}
              className="flex items-center justify-between rounded-lg px-3 py-2"
            >
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground">{option.nativeLabel}</div>
                <div className="text-xs text-muted-foreground">{option.englishLabel}</div>
              </div>
              {active ? <Check className="h-4 w-4 text-primary" /> : null}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
